import { RootState } from '@/store/reducers';

export const selectParametersExceededFilterMode = ({ portalSettings }: RootState) => portalSettings.parametersExceededFilterMode;
export const selectWeightLimitFilterMode = ({ portalSettings }: RootState) => portalSettings.weightLimitFilterMode;


